import { Module, Mutation } from '@/node_modules/vuex-module-decorators'
import BaseStore from '@/store/BaseStore'
import { Alert, ReturnCheckAlert } from '@/api'

@Module({
  name: 'AlertStore',
  namespaced: true,
  stateFactory: true
})
export default class AlertStore extends BaseStore {
  _items: Alert[] = []

  _returnCheckItems: ReturnCheckAlert[] = []

  get items(): Alert[] {
    return this._items
  }

  get returnCheckItems(): ReturnCheckAlert[] {
    return this._returnCheckItems
  }

  @Mutation
  public setItem(alert: Alert): void {
    this._items = [alert]
  }

  @Mutation
  public setItems(alerts: Alert[] = []): void {
    this._items = alerts
  }

  @Mutation
  public setReturnCheckItems(alerts: ReturnCheckAlert[] = []): void {
    this._returnCheckItems = alerts
  }

  @Mutation
  public deleteReturnCheckItem(index: number): void {
    this._returnCheckItems.splice(index, 1)
    this._returnCheckItems = [...this._returnCheckItems] // 算出プロパティが反応しない為、参照を切って強制的に監視を発動させる
  }
}
